/* ============================================
   FAQ（https://data.preducts.jp/faq.json）の読み込みと表示
   呼び出しは snippets/p-faq.liquid（一覧）と snippets/p-faq-search.liquid（お問い合わせページの検索）

   カテゴリ名の先頭に「@対象 | 」を付けると、その対象を指定したページにだけ表示する
     例：@b2b | 法人のお客様について → audience: 'b2b' のページにだけ「法人のお客様について」として表示
   目印のないカテゴリは一般向け（audience 未指定のページ＝FAQページ・お問い合わせページ）
   目印の判定では、前後の空白と全角の「＠」「｜」も許容する
   ============================================ */
(function() {
	if (window.PreFaq) return;

	var FAQ_JSON_URL = 'https://data.preducts.jp/faq.json';
	var MARKER_RE = /^\s*[@＠]\s*([A-Za-z0-9_-]+)\s*[|｜]?\s*/;
	var dataPromise = null;

	function load() {
		if (!dataPromise) {
			dataPromise = fetch(FAQ_JSON_URL).then(function(res) { return res.json(); });
		}
		return dataPromise;
	}

	function parseCategory(name) {
		name = name || '';
		var m = name.match(MARKER_RE);
		if (!m) return { audience: '', name: name };
		return { audience: m[1].toLowerCase(), name: name.slice(m[0].length) };
	}

	// audience が一致するカテゴリだけを、目印を外した名前で返す
	function filter(data, audience) {
		audience = (audience || '').toLowerCase();
		var result = [];
		(data || []).forEach(function(category) {
			var parsed = parseCategory(category.category);
			if (parsed.audience !== audience) return;
			result.push({ category: parsed.name, items: category.items || [] });
		});
		return result;
	}

	function escapeRegExp(s) {
		return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	function highlightText(html, query) {
		if (!query) return html;
		var re = new RegExp('(' + escapeRegExp(query) + ')(?![^<]*>)', 'gi');
		return html.replace(re, '<mark class="pre-faq-highlight">$1</mark>');
	}

	// 一覧表示（FAQページ・法人ページ）
	function renderList(root) {
		var faqBlock = root.querySelector('.pre-block');
		var input = root.querySelector('.pre-faq-search-input');
		var countEl = root.querySelector('.pre-faq-search-count');
		var noresultEl = root.querySelector('.pre-faq-search-noresult');
		var audience = root.getAttribute('data-audience');
		var showHeading = root.getAttribute('data-heading') === 'true';
		var items;
		var totalCount = 0;

		load().then(function(data) {
			var categories = filter(data, audience);

			// 該当カテゴリが無ければ、指定された囲みごと非表示
			if (categories.length === 0) {
				root.hidden = true;
				var wrap = root.closest('[data-p-faq-hide-empty]');
				if (wrap) wrap.hidden = true;
				return;
			}

			categories.forEach(function(category) {
				if (showHeading) {
					var h4 = document.createElement('h4');
					h4.className = 'pre-content-subtitle';
					h4.textContent = category.category;
					faqBlock.appendChild(h4);
				}

				var ul = document.createElement('ul');
				category.items.forEach(function(item) {
					var li = document.createElement('li');
					var q = document.createElement('p');
					q.className = 'pre-question';
					var span = document.createElement('span');
					span.textContent = item.question;
					q.appendChild(span);
					var a = document.createElement('p');
					a.className = 'pre-answer';
					a.innerHTML = item.answer.replace(/\n/g, '<br>');
					li.appendChild(q);
					li.appendChild(a);
					ul.appendChild(li);
				});
				faqBlock.appendChild(ul);
			});

			items = faqBlock.querySelectorAll('li');
			totalCount = items.length;
			items.forEach(function(li) {
				var answer = li.querySelector('.pre-answer');
				if (answer) li._origAnswer = answer.innerHTML;
			});
		});

		if (!input) return;

		function clearHighlights() {
			items.forEach(function(li) {
				var qSpan = li.querySelector('.pre-question span');
				var answer = li.querySelector('.pre-answer');
				if (qSpan) qSpan.innerHTML = qSpan.textContent;
				if (answer) answer.innerHTML = li._origAnswer;
			});
		}

		input.addEventListener('input', function() {
			if (!items) return;
			var query = this.value.trim().toLowerCase();
			var visibleCount = 0;

			clearHighlights();

			if (!query) {
				items.forEach(function(li) { li.style.display = ''; });
				faqBlock.querySelectorAll('h4, ul').forEach(function(el) { el.style.display = ''; });
				countEl.textContent = '';
				noresultEl.style.display = 'none';
				return;
			}

			items.forEach(function(li) {
				var qSpan = li.querySelector('.pre-question span');
				var answer = li.querySelector('.pre-answer');
				var text = (qSpan ? qSpan.textContent : '') + ' ' + (answer ? answer.textContent : '');
				if (text.toLowerCase().indexOf(query) !== -1) {
					li.style.display = '';
					visibleCount++;
					if (qSpan) qSpan.innerHTML = highlightText(qSpan.textContent, query);
					if (answer) answer.innerHTML = highlightText(li._origAnswer, query);
				} else {
					li.style.display = 'none';
				}
			});

			faqBlock.querySelectorAll('ul').forEach(function(ul) {
				var hasVisible = Array.prototype.some.call(ul.querySelectorAll('li'), function(li) {
					return li.style.display !== 'none';
				});
				ul.style.display = hasVisible ? '' : 'none';
				var h4 = ul.previousElementSibling;
				if (h4 && h4.tagName === 'H4') {
					h4.style.display = hasVisible ? '' : 'none';
				}
			});

			countEl.textContent = visibleCount + '件 / ' + totalCount + '件';
			noresultEl.style.display = visibleCount === 0 ? '' : 'none';
		});
	}

	// 横断検索（お問い合わせページ）：入力に応じて候補をオーバーレイ表示
	function initSearch(root) {
		var input = root.querySelector('.pre-faq-search-input');
		var overlay = root.querySelector('.pre-contact-faq-overlay');
		var audience = root.getAttribute('data-audience');
		var faqData = null;

		load().then(function(data) { faqData = filter(data, audience); });

		input.addEventListener('input', function() {
			if (!faqData) return;
			var query = this.value.trim().toLowerCase();

			if (!query) {
				overlay.innerHTML = '';
				overlay.style.display = 'none';
				return;
			}

			var results = [];
			faqData.forEach(function(category) {
				category.items.forEach(function(item) {
					var text = item.question + ' ' + item.answer;
					if (text.toLowerCase().indexOf(query) !== -1) {
						results.push(item);
					}
				});
			});

			if (results.length === 0) {
				overlay.innerHTML = '<p class="pre-contact-faq-noresult">該当するFAQが見つかりませんでした</p>';
				overlay.style.display = 'block';
				return;
			}

			var html = '<ul>';
			results.forEach(function(item) {
				var q = highlightText(item.question, query);
				var a = highlightText(item.answer.replace(/\n/g, '<br>'), query);
				html += '<li><p class="pre-contact-faq-q">' + q + '</p><p class="pre-contact-faq-a">' + a + '</p></li>';
			});
			html += '</ul>';
			overlay.innerHTML = html;
			overlay.style.display = 'block';
		});

		document.addEventListener('click', function(e) {
			if (!input.contains(e.target) && !overlay.contains(e.target)) {
				overlay.style.display = 'none';
			}
		});

		input.addEventListener('focus', function() {
			if (this.value.trim() && overlay.innerHTML) {
				overlay.style.display = 'block';
			}
		});
	}

	window.PreFaq = {
		load: load,
		filter: filter,
		renderList: renderList,
		initSearch: initSearch
	};
})();
